import React from "react";

const inputEuroReadOnly = (props) => (
  <div className="field-euro-wrapper">
    <input
      type="text"
      className="form-control"
      readOnly="readOnly"
      defaultValue={props.value}
      tabIndex="-1"
    />
    <span className="euro-text">€</span>
  </div>
);

export default inputEuroReadOnly;
